import React, { useState, useEffect, useCallback } from 'react'
import Topbar from './emailparts/Topbar'
import CanvasArea from './emailparts/CanvasArea'
import PropertiesPanel from './emailparts/PropertiesPanel'
import { Grid, Box } from '@mui/material'
import useEmailEditorStore from './utilities/emailEditorStore'
import { htmlExport } from './utilities/htmlExport'
import { generateThumbnailBlob,generateThumbnail } from './utilities/thumbnailGenerator'

function EmailEditor({ loadjson = null, saveemail }) {
  // Create a memoized save function that gets the current state
  const handleSaveEmail = useCallback(async () => {
    try {
      const htmltemplate = htmlExport()
      const template = useEmailEditorStore.getState().exportTemplate()
      const thumbnail = await generateThumbnail(htmltemplate, 300, 200)
      
      return {
        htmltemplate,
        template,
        thumbnail
      }
    } catch (error) {
      console.error('Error saving email:', error)
      throw error
    }
  }, []) // generateThumbnailBlob should be stable, but add it if it changes

  // Load template on mount or when loadjson changes
  useEffect(() => {
    if (loadjson) {
      useEmailEditorStore.getState().loadTemplate(loadjson)
    }
  }, [loadjson])

  // Expose the save function to parent component
  useEffect(() => {
    if (saveemail && typeof saveemail === 'function') {
      saveemail(handleSaveEmail)
    }
  }, [saveemail, handleSaveEmail])

  return (
    <>
      <Topbar />
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid size={8}>
            <CanvasArea />
          </Grid>
          <Grid size={4}>
            <PropertiesPanel />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default EmailEditor